import { Alert } from '@/components/basic';
import React from 'react';
import { useReserveForm } from '@/components/reserve/Reserve/ReserveFormProvider';

type ApprovalRequiredProps = {
  className: string;
};
export const ApprovalRequiredAlert: React.FC<ApprovalRequiredProps> = ({
  className = ''
}) => {
  const { currentResource } = useReserveForm();
  if (!currentResource?.is_approvable) return;
  return (
    <div className={className}>
      <Alert
        variant="tacticAlert"
        canDismiss={false}
        alertTitle={'Approval Required'}
        alertMessage="This workspace requires approval for reservations. Upon making a reservation an office admin will be notified and will need to approve or deny the reservation."
        className="mt-2 px-4 py-2"
      />
    </div>
  );
};
